// extracted by mini-css-extract-plugin
export var link = "_uk-0";